import React, {Component} from 'react';
import PropTypes from 'prop-types';
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import Button from "@material-ui/core/Button/Button";
import Dialog from "@material-ui/core/Dialog/Dialog";
import {inject, observer} from "mobx-react";
import {GD_OFF} from "../../routes/policies/PolicyDashboard";
import ArticleThumbnailList from "../article/ArticleThumbnailList";

@observer
class TransitionDialog extends Component {

    showArticle = (e, id) => {
        e.preventDefault();

        this.props.handleClose();
        this.props.showNewsArticle(id);

        const dashWrap = document.querySelector('.news__dash__wrap');
        const canvas = document.querySelector('.dash__offCanvas');
        const articleRef = '#' + id;
        const article = document.querySelector(articleRef);
        const articles = document.querySelectorAll('.dash__article');
        //remove all active articles first
        for (let i = 0; i < articles.length; i++) {
            if (articles[i].classList.contains('active-article')) {
                articles[i].classList.remove('active-article');
            }
        }
        article.classList.add('active-article');
        //push canvas left
        canvas.classList.add('canvas-is-open');
        //push main container left
        dashWrap.classList.add('push-left');
        dashWrap.classList.add('overlay-visible');

    };

    render() {
        const {dialogContent, dialogPres} = this.props;
        const {gdState, gdDescription, newsArticles} = dialogContent;
        const gdPresident = dialogPres;
        // console.log("dialogPres ", dialogPres);
        return (
            <Dialog
                open={gdState !== GD_OFF}
                onClose={this.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Host Nations - The Refugee Sim"}
                </DialogTitle>
                <DialogContent>
                    <p>
                        {gdDescription}
                    </p>
                    <p>
                        The current ATG president is: {gdPresident}
                    </p>
                    <ArticleThumbnailList articleList={newsArticles} openArticle={this.showArticle}/>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.handleClose} color="primary" variant={"contained"} autoFocus>
                        Okay
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

TransitionDialog.propTypes = {
    dialogContent: PropTypes.object.isRequired,
    handleClose: PropTypes.func.isRequired,
    showNewsArticle: PropTypes.func,
};

export default inject('articles')(TransitionDialog);
